import { type HStackProps } from '@pets-ui/HStack/HStack'
import { HStack } from '@pets-ui/HStack/HStack'
import * as stylex from '@stylexjs/stylex'
import { Children, type ReactNode } from 'react'
import { type WpCartMobileMediaQuery } from '../WpCartLayout/useWpCartResponsive'

const MOBILE: WpCartMobileMediaQuery = '@media (max-width: 983px)'

const MOBILE_ACTION_WIDTH = 30

const style = stylex.create({
  item: {
    display: 'flex',
    justifyContent: 'center',
  },
  first: {
    flex: {
      [MOBILE]: '1 0 100%',
      default: '1',
    },
    maxWidth: {
      [MOBILE]: `calc(100% - ${MOBILE_ACTION_WIDTH}px)`,
    },
  },
  second: {
    flex: {
      [MOBILE]: '1',
    },
    justifyContent: {
      [MOBILE]: 'flex-start',
    },
  },
  floating: {
    display: 'flex',
    justifyContent: 'flex-end',
    position: {
      [MOBILE]: 'absolute',
      default: 'relative',
    },
    transform: {
      [MOBILE]: 'translateY(25%)',
    },
    minWidth: {
      [MOBILE]: MOBILE_ACTION_WIDTH,
      default: 25,
    },
    right: {
      [MOBILE]: 0,
    },
    top: {
      [MOBILE]: 0,
    },
  },
})

export interface CartListItemLayoutProps extends HStackProps {
  children: ReactNode
}

export const CartListItemLayout = (props: CartListItemLayoutProps) => {
  const { children, ...rest } = props
  const [img, first, second, floating] = Children.toArray(children)
  return (
    <HStack gap={2} position="relative" flexWrap="nowrap" {...rest}>
      <div>{img}</div>
      <HStack alignItems="flex-start" gap={2} flex={1} overflow="hidden">
        <div {...stylex.props(style.first)}>{first}</div>
        <div {...stylex.props(style.item, style.second)}>{second}</div>
        <div {...stylex.props(style.item, style.floating)}>{floating}</div>
      </HStack>
    </HStack>
  )
}
